import { Moon, Sun, Ribbon } from "lucide-react";
import { useTheme } from "next-themes";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/contexts/LanguageContext";
import heroCarCutout from "@/assets/hero-car-cutout.webp";
import tsLogo from "@/assets/ts-logo.webp";

export function Header() {
  const {
    theme,
    setTheme
  } = useTheme();
  const {
    language,
    toggleLanguage,
    t
  } = useLanguage();
  return <header className="bg-gradient-hero-light dark:bg-gradient-hero relative overflow-hidden">
      {/* Subtle radial glow behind logo */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[400px] rounded-full bg-primary/8 dark:bg-primary/15 blur-3xl pointer-events-none" />

      {/* Hidden H1 for SEO crawlers - primary keyword "รถมือสอง" */}
      <h1 className="sr-only">
        รถมือสอง กรุงเทพ - TransShift รถมือสองคุณภาพ ราคาดี รถยนต์มือสอง รถเก๋งมือสอง รถบ้าน สภาพดี MotorVerified
      </h1>
      
      <div className="container pt-3 pb-6 relative z-10">
        <div className="flex items-center justify-between mb-4">
          <Ribbon className="h-6 w-6 text-foreground" />
          <div className="flex items-center gap-2">
            <Button variant="ghost" size="sm" onClick={toggleLanguage} className="hover:bg-transparent font-semibold text-foreground">
              {language === "en" ? "TH" : "EN"}
            </Button>
            <Button variant="ghost" size="icon" onClick={() => setTheme(theme === "dark" ? "light" : "dark")} className="hover:bg-transparent" aria-label={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"}>
              <Sun className="h-6 w-6 rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0" />
              <Moon className="absolute h-6 w-6 rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" />
            </Button>
          </div>
        </div>
        
        <div className="text-center space-y-3">
          <img
            src={tsLogo}
            alt="TransShift Logo"
            className="h-16 md:h-20 mx-auto object-contain"
            width={320}
            height={160}
            fetchPriority="high"
            decoding="async"
          />
          <h2 className="text-xl md:text-2xl text-muted-foreground">
            Premium Selected Pre-Owned Cars
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground">
            {t("MotorVerified ✓ • Direct Purchase •", "MotorVerified ✓ • ซื้อตรง •")}
            <br className="sm:hidden" />
            {t(" Mileage & Service History Reviewed", " เลขไมล์และประวัติเซอร์วิสตรวจสอบแล้ว")}
          </p>
        </div>
      </div>

      {/* Hero car image - transparent cutout, works on any background */}
      <div className="mt-2 md:mt-0 px-4 md:px-0 pb-6 relative z-10">
        <img
          src={heroCarCutout}
          alt="Premium pre-owned luxury car - TransShift รถมือสองพรีเมียม"
          className="w-full max-w-4xl mx-auto object-contain -scale-x-100 drop-shadow-2xl"
          width={1600}
          height={900}
          fetchPriority="high"
          decoding="async"
        />
      </div>

      {/* Gradient bottom border */}
      <div className="absolute bottom-0 inset-x-0 h-px bg-gradient-to-r from-transparent via-primary/30 to-transparent" />
    </header>;
}
